import { Box, Button, Icon, Tab, TabList, Text } from "monday-ui-react-core";
import { useEffect, useState } from "react";
import FormMandatory from "./FormMandatory";
import FormUserGuide from "./FormUserGuide";
// import FormOverview from "./FormOverview";
import FormBilling from "./FormBilling";
import FormSettings from "./security/FormSettings";
import FormOperationCounter from "./FormOperationCounter";

interface Props {
  onLoadChange: (isLoading: boolean) => void;
  context: any;
}

const FormDashboard: React.FC<Props> = ({ context, onLoadChange }) => {
  const [tabType, setTabType] = useState<number>();
  const [closeWelcome, setCloseWelcome] = useState<boolean>(false);

  useEffect(() => {
    async function init() {
      onLoadChange(true);
      await setTabType(0);

      onLoadChange(false);
    }
    init();
  }, []);

  async function handleTabChange(type) {
    await setTabType(type);
  }

  async function handleCloseWelcome(close = true) {
    await setCloseWelcome(close);
  }
  return (
    <>
      <div className="text-center mx-auto mt-3">
        {
          !closeWelcome && (
            <Box
              textColor={Box.textColors.PRIMARY_TEXT_COLOR}
              border={Box.borders.DEFAULT}
              rounded={Box.roundeds.SMALL}
              className="text-left p-3 leading-8 w-4/5 m-auto"
            >
              <div className="relative">
                <Text
                  className="text-xl font-medium text-center"
                  type={Text.types.TEXT2}
                  color={Text.colors.PRIMARY}
                >
                  Welcome!
                </Text>
                <Button
                  onClick={() => handleCloseWelcome()}
                  className="mr-2 absolute right-0 top-0"
                  size="md"
                  color={Button.colors.ON_INVERTED_BACKGROUND}
                >
                  <Icon
                    iconType={Icon.type.ICON_FONT}
                    icon="fa-solid fa-x"
                  ></Icon>
                </Button>
              </div>

              <div className="text-sm mt-4">
                <Text
                  type={Text.types.TEXT2}
                  color={Text.colors.PRIMARY}
                  ellipsis={false}
                  className="mb-2"
                >
                  FieldValidator Pro is a vital monday.com app designed to
                  enhance data integrity and streamline workflow management.
                </Text>
                <Text
                  type={Text.types.TEXT2}
                  color={Text.colors.PRIMARY}
                  ellipsis={false}
                  className="mb-2"
                >
                  To get started, please fill the "Conditions table" tab and
                  create the desired automation recipe in the monday automation
                  center for the app to function effectively.
                </Text>
                <Text
                  type={Text.types.TEXT2}
                  color={Text.colors.PRIMARY}
                  ellipsis={false}
                  className="mb-2"
                >
                  Additionally, check the settings table for more options.
                </Text>
                <Text
                  type={Text.types.TEXT2}
                  color={Text.colors.PRIMARY}
                  ellipsis={false}
                >
                  For more detailed step-by-step instructions, please check our
                  user guide.
                </Text>
              </div>
            </Box>
          )
          // : <div className="w-1/2 mx-auto text-right">
          //     <Button onClick={() => handleCloseWelcome(false)} className='mr-2 text-right' size='md' color={Button.colors.ON_INVERTED_BACKGROUND}>
          //         <Icon iconType={Icon.type.ICON_FONT} icon='fa-solid fa-question'></Icon>
          //     </Button>
          // </div>
        }

        <TabList className="mt-8 w-4/5 mx-auto" tabType="stretched">
          <Tab
            onClick={() => {
              handleTabChange(0);
            }}
          >
            Conditions Table
          </Tab>
          <Tab
            onClick={() => {
              handleTabChange(1);
            }}
          >
            User Guide
          </Tab>
          <Tab
            onClick={() => {
              handleTabChange(2);
            }}
          >
            Operation Counter
          </Tab>
          <Tab
            onClick={() => {
              handleTabChange(3);
            }}
          >
            Billing
          </Tab>
          <Tab
            onClick={() => {
              handleTabChange(4);
            }}
          >
            Settings
          </Tab>
        </TabList>
        {tabType === 0 ? (
          <FormMandatory></FormMandatory>
        ) : tabType === 1 ? (
          <FormUserGuide></FormUserGuide>
        ) : tabType === 2 ? (
          <FormOperationCounter context={context}></FormOperationCounter>
        ) : tabType === 3 ? (
          <FormBilling></FormBilling>
        ) : tabType === 4 ? (
          <FormSettings context={context}></FormSettings>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default FormDashboard;